import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import maplibregl from "maplibre-gl";
import type { FeatureCollection } from "geojson";
import { FilterType } from "./Filter";
import HotSpotStatus from "../../common/HotSpotStatus";
import _ from "lodash";
import ProvinceBbox from "../../../province-bbox.json";
import RegionBbox from "../../../region-bbox.json";
import DistrictBbox from "../../../district-bbox.json";
import SubDistrict from "../../../subDistrict-bbox.json";
import moment from "moment-timezone";
import Provinces from "../../../Provinces.json";
import axios from "axios";
interface MapsPropType {
  filter?: FilterType;
}

function Maps({ filter }: MapsPropType) {
  const mapContainer = useRef<any>(null);
  const [openHotSpotStatus, setOpenHotSpotStatus] = useState(false);
  const [featurePoint, setFeaturePoint] = useState<any>();
  const [coordinatePoint, setCoordinatePoint] = useState();
  const [layers, setLayers] = useState<any>();
  const [styleMap, setStyleMap] = useState();
  const [mapLibre, setMapLibre] = useState<any>(null);
  const [currentPosition, setCurrentPosition] = useState<any>([]);
  const [geoCurrentPosition, setGeoCurrentPosition] =
    useState<FeatureCollection>({
      type: "FeatureCollection",
      features: [
        {
          id: "64f587dc56c57d51de110850",
          type: "Feature",
          geometry: { type: "Point", coordinates: currentPosition },
          properties: {},
        },
      ],
    });

  const getCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      setCurrentPosition([longitude, latitude]);
      setGeoCurrentPosition({
        type: "FeatureCollection",
        features: [
          {
            id: "64f587dc56c57d51de110850",
            type: "Feature",
            geometry: { type: "Point", coordinates: [longitude, latitude] },
            properties: {},
          },
        ],
      });
    });
  };
  const handleFilterBbox = (filter: any) => {
    if (!mapLibre) return;
    if (filter?.countryType?.id === 2) {
      return;
    }
    let bbox = [];
    if (!filter) {
      mapLibre.fitBounds([
        [97.33396, 5.6252],
        [105.647, 20.47466],
      ]);
    } else {
      if (filter?.provinceGroup?.id === 1) {
        mapLibre.fitBounds([
          [97.33396, 5.6252],
          [105.647, 20.47466],
        ]);
      } else if (filter?.provinceGroup?.id === 2) {
        let northProvince = Provinces.filter((e) => e.Group17Provinces === 1);
        let bboxs: any = [];
        _.map(northProvince, (prov) => {
          const found = _.find(ProvinceBbox.features, {
            properties: { PV_IDN: Number(prov.ProvinceCode) },
          });
          if (found) {
            let data: any = found?.properties.bbox
              .split(",")
              .map((coord) => parseFloat(coord));
            bboxs.push(data);
          }
        });

        if (bboxs.length > 0) {
          let minX = bboxs[0][0];
          let minY = bboxs[0][1];
          let maxX = bboxs[0][2];
          let maxY = bboxs[0][3];

          for (let i = 1; i < bboxs.length; i++) {
            minX = Math.min(minX, bboxs[i][0]);
            minY = Math.min(minY, bboxs[i][1]);
            maxX = Math.max(maxX, bboxs[i][2]);
            maxY = Math.max(maxY, bboxs[i][3]);
          }
          bbox = [minX, minY, maxX, maxY];
        } else {
          return;
        }
      }
      if (
        filter?.region?.RegionCode !== "0" ||
        (filter?.region?.RegionCode !== "0" &&
          filter?.province[0].ProvinceCode === "0")
      ) {
        let region = RegionBbox.features.find(
          (feature) =>
            feature.properties.RE_ROYIN === filter?.region?.RegionCode
        );
        if (region) {
          const bboxArray: any = region?.properties.bbox
            .split(",")
            .map((coord) => parseFloat(coord));
          bbox = bboxArray;
        }
        mapLibre.fitBounds(
          [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ],
          { padding: 20 }
        );
      }
      if (
        filter?.province ||
        (filter?.province && filter?.district?.DistrictCode === "0")
      ) {
        const hasProvinceCodeZero = filter.province.some(
          (item: any) => item.ProvinceCode === "0"
        );
        if (!hasProvinceCodeZero && filter.province.length === 1) {
          let province = ProvinceBbox.features.find(
            (feature) =>
              feature.properties.PV_IDN ===
              Number(filter.province[0].ProvinceCode)
          );

          const bboxArray: any = province?.properties.bbox
            .split(",")
            .map((coord) => parseFloat(coord));

          bbox = bboxArray;
        } else {
          let bboxs: any = [];
          _.map(filter.province, (prov) => {
            const found = _.find(ProvinceBbox.features, {
              properties: { PV_IDN: Number(prov.ProvinceCode) },
            });
            if (found) {
              let data: any = found?.properties.bbox
                .split(",")
                .map((coord) => parseFloat(coord));
              bboxs.push(data);
            }
          });

          if (bboxs.length > 0) {
            let minX = bboxs[0][0];
            let minY = bboxs[0][1];
            let maxX = bboxs[0][2];
            let maxY = bboxs[0][3];

            for (let i = 1; i < bboxs.length; i++) {
              minX = Math.min(minX, bboxs[i][0]);
              minY = Math.min(minY, bboxs[i][1]);
              maxX = Math.max(maxX, bboxs[i][2]);
              maxY = Math.max(maxY, bboxs[i][3]);
            }
            bbox = [minX, minY, maxX, maxY];
          } else {
            return;
          }
        }

        mapLibre.fitBounds(
          [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ],
          { padding: 20 }
        );
      }
      if (
        filter?.district?.DistrictCode !== "0" ||
        (filter?.district?.DistrictCode !== "0" &&
          filter?.subdistrict?.SubdistrictCode === "0")
      ) {
        let district = DistrictBbox?.features?.find(
          (feature) =>
            feature.properties.AP_IDN === Number(filter.district.DistrictCode)
        );
        if (district) {
          const bboxArray: any = district?.properties.bbox
            .split(",")
            .map((coord) => parseFloat(coord));
          bbox = bboxArray;
        }
        mapLibre.fitBounds(
          [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ],
          { padding: 20 }
        );
      }
      if (filter?.subdistrict?.SubdistrictCode !== "0") {
        // @ts-ignore
        let subdistrict = SubDistrict.features.find(
          (feature: any) =>
            feature.properties.TB_IDN ===
            Number(filter.subdistrict.SubdistrictCode)
        );

        if (subdistrict) {
          const bboxArray: any = subdistrict?.properties.bbox
            .split(",")
            .map((coord: any) => parseFloat(coord));
          bbox = bboxArray;
        }

        mapLibre.fitBounds(
          [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ],
          { padding: 20 }
        );
      }
    }
  };
  const getStyleMapLibre = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_VALLARIS}/core/api/styles/1.0-beta/styles/64e5d885d0d61ab0e889ddd5?api_key=${process.env.REACT_APP_VALLARIS_API_KEY}`
      );
      if (data) {
        _.forEach(data.layers, (layer) => {
          if (
            layer.id === "modis-data" ||
            layer.id === "viirs-data-Suomi_NPP" ||
            layer.id === "viirs-data-NOAA-20"
          ) {
            if (layer.id === "viirs-data-Suomi_NPP") {
              let startOfDay = new Date().setHours(0, 0, 0, 0);
              let endOfDay = new Date().setHours(23, 59, 59, 999);
              let startOfDayTimestamp = moment(startOfDay)
                .add(7, "hours")
                .unix();
              let endOfDayTimestamp = moment(endOfDay).add(7, "hours").unix();
              layer.filter = [
                "all",
                [
                  "all",
                  ["==", ["get", "ct_en"], "Thailand"],
                  [
                    "all",
                    [">=", ["get", "timestamp"], startOfDayTimestamp],
                    ["<", ["get", "timestamp"], endOfDayTimestamp],
                  ],
                ],
                ["==", ["get", "instrument"], "VIIRS"],
                ["==", ["get", "satellite"], "Suomi NPP"],
              ];
            } else if (
              layer.id === "modis-data" ||
              layer.id === "viirs-data-NOAA-20"
            ) {
              layer.layout = { visibility: "none" };
            }
          }
        });
        setStyleMap(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handleGeoCurrentLocation = () => {
  //   let isHaveLayer = mapLibre?.getSource("current-position-source");
  //   console.log("isHaveLayer :>> ", isHaveLayer);
  //   if (!isHaveLayer) {
  //     mapLibre?.addSource(`current-position-source`, {
  //       type: "geojson",
  //       data: geoCurrentPosition,
  //       cluster: false,
  //       clusterMaxZoom: 14,
  //       clusterRadius: 50,
  //     });

  //     mapLibre?.addLayer({
  //       id: `background-current-position`,
  //       type: "circle",
  //       source: `current-position`,
  //       filter: ["!", ["has", "point_count"]],
  //       paint: {
  //         "circle-color": `#C34A25`,
  //         "circle-radius": 10,
  //         "circle-opacity": 0.2,
  //       },
  //     });

  //     mapLibre?.addLayer({
  //       id: `current-position`,
  //       type: "circle",
  //       source: `current-position`,
  //       filter: ["!", ["has", "point_count"]],
  //       paint: {
  //         "circle-color": `#C34A25`,
  //         "circle-radius": 10,
  //         "circle-stroke-width": 1,
  //         "circle-stroke-color": "#fff",
  //       },
  //     });
  //   }
  // };
  // const handleFilterMap = () => {
  //   mapLibre.getLayer("viirs-data") && mapLibre.removeLayer("viirs-data");
  //   mapLibre.getSource("viirs-map") && mapLibre.removeSource("viirs-map");
  //   mapLibre.getLayer("modis-data") && mapLibre.removeLayer("modis-data");
  //   mapLibre.getSource("modis-map") && mapLibre.removeSource("modis-map");

  //   if (!filter) {
  //     mapLibre.addSource("viirs-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/viirs?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "viirs-data",
  //       type: "circle",
  //       source: "viirs-map",
  //       "source-layer": "64eec838905f9e8c2857d2de",
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }

  //   if (filter && filter.satellite === "VIIRS") {
  //     mapLibre.addSource("viirs-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/viirs?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "viirs-data",
  //       type: "circle",
  //       source: "viirs-map",
  //       "source-layer": "64eec838905f9e8c2857d2de",
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  //   if (filter && filter.satellite === "MODIS") {
  //     mapLibre.addSource("modis-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/modis?token=${accessToken}`,
  //     });

  //     mapLibre.addLayer({
  //       id: "modis-data",
  //       type: "circle",
  //       source: "modis-map",
  //       "source-layer": "64ec7c0ff5c9ab0c1927f098",
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  //   if (filter && filter.satellite === "Suomi NPP") {
  //     mapLibre.addSource("viirs-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/viirs?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "viirs-data",
  //       type: "circle",
  //       source: "viirs-map",
  //       "source-layer": "64eec838905f9e8c2857d2de",
  //       filter: ["==", ["get", "satellite"], "NOAA-20"],
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  //   if (filter && filter.satellite === " NOAA-20") {
  //     mapLibre.addSource("viirs-map", {
  //       type: "vector",
  //       url: `${process.env.REACT_APP_API_CLAY_STONE}/api/1.0/resources/tiles/viirs?token=${accessToken}`,
  //     });
  //     mapLibre.addLayer({
  //       id: "viirs-data",
  //       type: "circle",
  //       source: "viirs-map",
  //       "source-layer": "64eec838905f9e8c2857d2de",
  //       filter: ["==", ["get", "satellite"], "Suomi NPP"],
  //       paint: {
  //         "circle-color": [
  //           "match",
  //           ["get", "lu_code"],
  //           1,
  //           "#91E478",
  //           2,
  //           "#E865EE",
  //           3,
  //           "#3B923E",
  //           4,
  //           "#AF692E",
  //           5,
  //           "#F8EA6E",
  //           6,
  //           "#C3C3BE",
  //           "#F0B24A",
  //         ],
  //         "circle-radius": 4,
  //       },
  //     });
  //   }
  // };
  // const handleMouseMove = () => {
  //   mapLibre.on("mouseenter", "viirs-data", () => {
  //     mapLibre.getCanvas().style.cursor = "pointer";
  //   });
  //   mapLibre.on("mouseleave", "viirs-data", () => {
  //     mapLibre.getCanvas().style.cursor = "";
  //   });
  //   mapLibre.on("mouseenter", "modis-data", () => {
  //     mapLibre.getCanvas().style.cursor = "pointer";
  //   });
  //   mapLibre.on("mouseleave", "modis-data", () => {
  //     mapLibre.getCanvas().style.cursor = "";
  //   });
  // };

  // const handleMouseClick = () => {
  //   mapLibre.on("click", "viirs-data", (e: any) => {
  //     const coordinates = e.features[0].geometry.coordinates.slice();
  //     setFeaturePoint(e.features[0]);
  //     setCoordinatePoint(coordinates);
  //     setTimeout(() => {
  //       setOpenHotSpotStatus(true);
  //     }, 300);
  //   });
  //   mapLibre.on("click", "modis-data", (e: any) => {
  //     const coordinates = e.features[0].geometry.coordinates.slice();
  //     setFeaturePoint(e.features[0]);
  //     setCoordinatePoint(coordinates);
  //     setTimeout(() => {
  //       setOpenHotSpotStatus(true);
  //     }, 300);
  //   });
  // };

  // useEffect(() => {
  //   const map = new maplibregl.Map({
  //     container: mapContainer.current,
  //     style:
  //       "https://vallaris.dragonfly.gistda.or.th/core/api/styles/1.0-beta/styles/64e5d885d0d61ab0e889ddd5?api_key=zU7TIfJzSmyecfqoKGvzBM8rpgcDXkAW1HdPHjnfayQTu7iEyQvfatnpzpVZ9eVg",
  //     zoom: 6,
  //     maxZoom: 16,
  //     bounds: [
  //       [97.33396, 5.6252],
  //       [105.647, 20.47466],
  //     ],
  //     minZoom: 0,
  //     bearing: 0,
  //   });
  //   map.on("load", () => {
  //     setMapLibre(map);
  //   });

  //   return () => {
  //     if (map) {
  //       map.remove();
  //     }
  //   };
  // }, [mapStyle]);

  useEffect(() => {
    getStyleMapLibre();
  }, []);
  useEffect(() => {
    if (!styleMap) return;
    const map = new maplibregl.Map({
      container: mapContainer.current,
      style: styleMap,
      zoom: 6,
      maxZoom: 16,
      bounds: [
        [97.33396, 5.6252],
        [105.647, 20.47466],
      ],
      minZoom: 0,
      bearing: 0,
    });

    map.on("load", () => {
      setMapLibre(map);
      getCurrentPosition();

      let allLayer = map?.getStyle()?.layers;
      let layerData = _.filter(
        allLayer,
        (layer: any) => layer.metadata["vallaris:group"] === "layers"
      );
      setLayers(layerData);
    });

    return () => {
      if (map) {
        map?.remove();
      }
    };
  }, [styleMap]);

  useEffect(() => {
    let isHaveLayer = mapLibre?.getSource("current-position");
    if (!isHaveLayer) {
      if (currentPosition.length > 0 && mapLibre) {
        mapLibre?.addSource(`current-position`, {
          type: "geojson",
          data: geoCurrentPosition,
          cluster: false,
          clusterMaxZoom: 14,
          clusterRadius: 50,
        });

        mapLibre?.addLayer({
          id: `background-current-position`,
          type: "circle",
          source: `current-position`,
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": `#C34A25`,
            "circle-radius": 10,
            "circle-opacity": 0.2,
          },
        });

        mapLibre?.addLayer({
          id: `user-current-position`,
          type: "circle",
          source: `current-position`,
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": `#C34A25`,
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
        });
      }
    }
  }, [mapLibre, geoCurrentPosition]);

  useEffect(() => {
    if (!layers || !mapLibre) return;
    if (!filter) {
      let startOfDay = new Date().setHours(0, 0, 0, 0);
      let endOfDay = new Date().setHours(23, 59, 59, 999);
      let startOfDayTimestamp = moment(startOfDay).add(7, "hours").unix();
      let endOfDayTimestamp = moment(endOfDay).add(7, "hours").unix();
      _.map(layers, (layer) => {
        if (layer?.id === "viirs-data-Suomi_NPP") {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          mapLibre?.setFilter("viirs-data-Suomi_NPP", [
            "all",
            [
              "all",
              ["==", ["get", "ct_en"], "Thailand"],
              [
                "all",
                [">=", ["get", "timestamp"], startOfDayTimestamp],
                ["<", ["get", "timestamp"], endOfDayTimestamp],
              ],
            ],
            ["==", ["get", "instrument"], "VIIRS"],
            ["==", ["get", "satellite"], "Suomi NPP"],
          ]);
        } else if (
          layer.id === "modis-data" ||
          layer.id === "viirs-data-NOAA-20"
        ) {
          mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
        }
      });
    } else if (filter) {
      let filterLayer: any = [];
      if (filter.countryType?.id === 1) {
        filterLayer.push(["==", ["get", "ct_en"], "Thailand"]);
        if (filter.provinceGroup?.id === 2) {
          let provinceNorth = Provinces.filter((e) => e.Group17Provinces === 1);
          let filterProvince: any = [];
          provinceNorth.forEach((province) => {
            if (province.ProvinceCode !== "0") {
              filterProvince.push([
                "==",
                ["get", "pv_code"],
                province.ProvinceCode,
              ]);
            }
          });
          filterLayer.push(["any", ...filterProvince]);
        }
        if (filter.region?.RegionCode !== "0") {
          filterLayer.push([
            "==",
            ["get", "re_royin"],
            filter.region?.RegionCode,
          ]);
        }
        if (filter.province) {
          const hasProvinceCodeZero = filter.province.some(
            (item) => item.ProvinceCode === "0"
          );
          if (!hasProvinceCodeZero) {
            let filterProvince: any = [];
            filter.province.forEach((province) => {
              if (province.ProvinceCode !== "0") {
                filterProvince.push([
                  "==",
                  ["get", "pv_code"],
                  province.ProvinceCode,
                ]);
              }
            });
            filterLayer.push(["any", ...filterProvince]);
          }
        }
        if (filter.district?.DistrictCode !== "0") {
          filterLayer.push([
            "==",
            ["get", "ap_idn"],
            Number(filter.district?.DistrictCode),
          ]);
        }
        if (filter.subdistrict?.DistrictCode !== "0") {
          filterLayer.push([
            "==",
            ["get", "tb_idn"],
            Number(filter.subdistrict?.SubdistrictCode),
          ]);
        }
      } else if (filter.countryType?.id === 2) {
        filterLayer.push(["==", ["get", "asian"], 1]);
      }
      if (filter.fileName) {
        filterLayer.push(["==", ["get", "file_name"], filter.fileName]);
      }
      if (filter.startDate && filter.endDate === null) {
        let startOfDate = new Date(filter.startDate).setHours(0, 0, 0, 0);
        let endOfDate = new Date(filter.startDate).setHours(23, 59, 59, 999);
        let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
        let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
        filterLayer.push([
          "all",
          [">=", ["get", "timestamp"], startOfDayTimestamp],
          ["<", ["get", "timestamp"], endOfDayTimestamp],
        ]);
      }
      if (filter.startDate && filter.endDate) {
        let startOfDate = new Date(filter.startDate).setHours(0, 0, 0, 0);
        let endOfDate = new Date(filter.endDate).setHours(23, 59, 59, 999);
        let startOfDayTimestamp = moment(startOfDate).add(7, "hours").unix();
        let endOfDayTimestamp = moment(endOfDate).add(7, "hours").unix();
        filterLayer.push([
          "all",
          [">=", ["get", "timestamp"], startOfDayTimestamp],
          ["<", ["get", "timestamp"], endOfDayTimestamp],
        ]);
      }
      if (filter?.satellite === "VIIRS") {
        let filterDataNPP = [
          "all",
          ["all", ...filterLayer],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "Suomi NPP"],
        ];
        let filterDataNOAA = [
          "all",
          ["all", ...filterLayer],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "NOAA-20"],
        ];
        _.map(layers, (layer) => {
          if (
            layer?.id === "viirs-data-Suomi_NPP" ||
            layer?.id === "viirs-data-NOAA-20"
          ) {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          } else if (layer.id === "modis-data") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
        mapLibre?.setFilter("viirs-data-Suomi_NPP", filterDataNPP);
        mapLibre?.setFilter("viirs-data-NOAA-20", filterDataNOAA);
      } else if (filter?.satellite === "MODIS") {
        let filterData = [
          "all",
          ["all", ...filterLayer],
          ["==", ["get", "instrument"], "MODIS"],
        ];
        _.map(layers, (layer) => {
          if (layer?.id === "modis-data") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          } else if (
            layer?.id === "viirs-data-Suomi_NPP" ||
            layer?.id === "viirs-data-NOAA-20"
          ) {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
        mapLibre?.setFilter("modis-data", filterData);
      } else if (filter.satellite === "Suomi NPP") {
        let filterData = [
          "all",
          ["all", ...filterLayer],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "Suomi NPP"],
        ];
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-Suomi_NPP") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          } else if (
            layer?.id === "modis-data" ||
            layer?.id === "viirs-data-NOAA-20"
          ) {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
        mapLibre?.setFilter("viirs-data-Suomi_NPP", filterData);
      } else if (filter?.satellite === "NOAA-20") {
        let filterData = [
          "all",
          ["all", ...filterLayer],
          ["==", ["get", "instrument"], "VIIRS"],
          ["==", ["get", "satellite"], "NOAA-20"],
        ];
        _.map(layers, (layer) => {
          if (layer?.id === "viirs-data-NOAA-20") {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "visible");
          } else if (
            layer?.id === "modis-data" ||
            layer?.id === "viirs-data-Suomi_NPP"
          ) {
            mapLibre?.setLayoutProperty(layer?.id, "visibility", "none");
          }
        });
        mapLibre?.setFilter("viirs-data-NOAA-20", filterData);
      }
    }
    handleFilterBbox(filter);
  }, [filter, mapLibre]);

  useEffect(() => {
    _.forEach(layers, (layer) => {
      mapLibre.on("mouseenter", layer.id, () => {
        mapLibre.getCanvas().style.cursor = "pointer";
      });
      mapLibre.on("mouseleave", layer.id, () => {
        mapLibre.getCanvas().style.cursor = "";
      });
      mapLibre.on("click", layer.id, (e: any) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        setFeaturePoint(e.features[0]);
        setCoordinatePoint(coordinates);
        setTimeout(() => {
          setOpenHotSpotStatus(true);
        }, 300);
      });
    });

    return () => {
      _.forEach(layers, (layer) => {
        mapLibre.off("mouseenter", layer.id);
        mapLibre.off("mouseleave", layer.id);
        mapLibre.off("click", layer.id);
      });
    };
  }, [mapLibre]);

  // useEffect(() => {
  //   if (!mapLibre) return;

  //   //เรียกดูข้อมูล style ของแผนที่ทั้งหมด
  //   console.log("All style :>> ", mapLibre?.getStyle()?.layers);

  //   let allLayer = mapLibre?.getStyle()?.layers;

  //   //กรองข้อมูล style รูปแบบของแผนที่ Topography Hybrid Satellite
  //   let mapPhotograph = _.filter(
  //     allLayer,
  //     (layer) => layer.metadata["vallaris:group"] === "Topography"
  //   );

  //   let mapHybridge = _.filter(
  //     allLayer,
  //     (layer) => layer.metadata["vallaris:group"] === "Hybrid"
  //   );

  //   let mapSatellite = _.filter(
  //     allLayer,
  //     (layer) => layer.metadata["vallaris:group"] === "Satellite"
  //   );

  //   mapLibre?.setLayoutProperty("modis-data", "visibility", "none");
  //   mapLibre?.setLayoutProperty("viirs-data-Suomi_NPP", "visibility", "none");
  //   mapLibre?.setLayoutProperty("viirs-data-NOAA-20", "visibility", "none");

  //   // mapLibre?.setLayoutProperty("Province", "visibility", "visible");
  //   // mapLibre?.setLayoutProperty("Amphoe", "visibility", "visible");
  //   // mapLibre?.setLayoutProperty("Tambon", "visibility", "visible");

  //   //กรองข้อมูลของ layer จุดความร้อน
  //   let layerData = _.filter(
  //     allLayer,
  //     (layer) => layer.metadata["vallaris:group"] === "layers"
  //   );

  //   // _.map(mapPhotograph, (map) => {
  //   //   mapLibre?.setLayoutProperty(map.id, "visibility", "none");
  //   // });

  //   // _.map(mapSatellite, (map) => {
  //   //   mapLibre?.setLayoutProperty(map.id, "visibility", "visible");
  //   // });

  //   console.log("mapPhotograph", mapPhotograph);
  //   console.log("mapHybridge :>> ", mapHybridge);
  //   console.log("mapHybridge :>> ", mapHybridge);
  //   console.log("mapSatellite", mapSatellite);
  //   console.log("layerData", layerData);
  // }, [mapLibre]);

  // useEffect(() => {
  //   if (!mapLibre) return;
  //   handleGeoCurrentLocation();
  // }, [mapLibre, geoCurrentPosition]);

  // useEffect(() => {
  //   if (!mapLibre) return;
  //   handleFilterMap();
  //   handleMouseMove();
  //   handleMouseClick();
  // }, [mapLibre, filter]);

  // useEffect(() => {
  //   getCurrentPosition();
  // }, []);

  return (
    <div className="w-full relative h-full rounded-[32px] bg-transparent">
      <div
        className="w-full h-full max-h-full rounded-[32px]"
        ref={mapContainer}
      />
      <HotSpotStatus
        open={openHotSpotStatus}
        hideStatusBar={true}
        features={featurePoint}
        coordinate={coordinatePoint}
        onClose={() => setOpenHotSpotStatus(false)}
      />
      <Link to={`/map`}>
        <div className="absolute bottom-8 rounded-lg right-2 w-auto h-auto shadow-z8 bg-primary-contrast p-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5.55V5C15 2.79086 13.2091 1 11 1H10.45M15 10.45V11C15 13.2091 13.2091 15 11 15H10.45M5.55 15H5C2.79086 15 1 13.2091 1 11V10.45M1 5.55V5C1 2.79086 2.79086 1 5 1H5.55"
              stroke="#8E8E8E"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </Link>
    </div>
  );
}

export default Maps;
